module.exports = __webpack_public_path__ + "static/media/test-kit.380b739b.svg";